/** Chat settings tab — placeholder for chat preferences */
function ChatSettings() {
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">Chat settings coming soon.</p>
    </div>
  );
}

export default ChatSettings;
